/**
 * --------------------------------------------------------------------------
 * Custom Tooltips for Chart.js (vv2.0.0-beta.0): index.umd.js
 * Licensed under MIT (https://github.com/@coreui/coreui-chartjs/LICENSE)
 * --------------------------------------------------------------------------
 */

// eslint-disable-next-line no-unused-vars
import Chart from 'chart.js'
import customTooltips from './src/custom-tooltips'

export default {
  customTooltips
}
